<template>
    <b-input-group class="ml-3">
        <b-form-input v-model="texto" @keyup="cambio" @change="cambio" ></b-form-input>
        <b-input-group-append>
            <b-button variant="outline-success" @click="cambio">
                <i class="fas fa-search"></i>
            </b-button>
        </b-input-group-append>
    </b-input-group>
</template>

<script>
    export default {
        name: "Search",
        model: {
            prop: 'input',
            event: 'search'
        },
        props: {
            input: String
        },
        data() {
            return {
                texto: ''
            }
        },
        methods: {
            cambio: function () {
                this.$emit('search', this.texto);
            }
        }
    }
</script>

<style scoped>

</style>